import { useMutation } from 'react-query';

import { putHubNewLocation as putHubNewLocationApi } from 'api/InteractiveMap/putHubNewLocation';

const usePutHubNewLocation = () => {
  const { isSuccess, mutate: putHubNewLocation, isLoading } = useMutation(putHubNewLocationApi);

  return {
    isSuccess,
    putHubNewLocation,
    isLoading,
  };
};

export default usePutHubNewLocation;
